import React from "react";
import { Box, Skeleton } from "@mui/material";
import type { AwardTab } from "../../routes";
import CreateSectionHeader from "../CreateNotice/CreateSectionHeader";
import { AWARDS_CRUMB, CERTIFICATES_CRUMB } from "./certificateCrumbs";
import { SettingsBesideCertificateSkeleton } from "./CertificateTemplateSkeleton";

/**
 * Shown while an Award loads: its header straight away, then grey tabs and
 * either Awardee rows or the details beside the certificate, whichever tab is open.
 */
const AwardSkeleton: React.FC<{ tab: AwardTab }> = ({ tab }) => (
  <>
    <CreateSectionHeader
      title="Award"
      crumbs={[CERTIFICATES_CRUMB, AWARDS_CRUMB]}
    />
    <Box role="status" aria-label="Loading Award">
      <Box
        sx={{
          display: "flex",
          gap: 3,
          mb: 3,
          pb: 1.5,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Skeleton variant="text" width={110} height={28} />
        <Skeleton variant="text" width={60} height={28} />
      </Box>
      {tab === "award" ? (
        <SettingsBesideCertificateSkeleton />
      ) : (
        <Box sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
          <Box sx={{ px: 3, py: 2, borderBottom: 1, borderColor: "divider" }}>
            <Skeleton variant="rounded" height={48} />
          </Box>
          <Box
            sx={{
              px: 3,
              py: 2.5,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {[0, 1, 2, 3].map((row) => (
              <Skeleton key={row} variant="rounded" height={74} />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  </>
);

/** Shown while a new Award's page loads: its header and the details beside the certificate. */
export const NewAwardSkeleton: React.FC = () => (
  <>
    <CreateSectionHeader
      title="New Award"
      crumbs={[CERTIFICATES_CRUMB, AWARDS_CRUMB]}
    />
    <Box role="status" aria-label="Loading Award">
      <SettingsBesideCertificateSkeleton />
    </Box>
  </>
);

export default AwardSkeleton;
